import { render, staticRenderFns } from "./RevenueReport.vue?vue&type=template&id=327d4d0c&scoped=true"
import script from "./RevenueReport.vue?vue&type=script&lang=js"
export * from "./RevenueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d4d0c",
  null
  
)

export default component.exports